import request from '../../axios';

export const getInstallmentPrice = async (loanRequestGuid?: string) => {
  const {data}: {data: IGetInstallmentPrice} = await request.get(
    `/api/v2/payment/payment-installment/taken-loan/` + loanRequestGuid,
  );

  return data;
};
